<button
  type="button"
  class="block w-full max-w-[28rem] mx-auto text-center cursor-pointer px-4 py-2.5 text-sm font-normal leading-snug text-gray-1100 bg-gray-200 border border-transparent rounded-[0.25rem] transition-colors hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
  [disabled]="disabled()"
  (click)="clicked.emit()">
  {{ label() }}
</button>
